import CTL_Button from "@/compo/CTL_Button";
import { CTL_GroupLabel } from "@/compo/CTL_GroupLabel";
import { CTL_Input } from "@/compo/CTL_Input";
import axios from "axios";
import { useState } from "react";

import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

interface Prop_NewNoticeForm{
  onUpdate?:(info:unknown)=>void;
}

export default function NewNoticeForm( prop:Prop_NewNoticeForm ) {
  const [showNewinput, setShowNewInput] = useState(false);
  const [subject, setSubject] = useState("");
  const [newNoticeContents, setNewNoticeContents] = useState("");

  async function _commitAdd() {
    const { data } = await axios.post("/notice/add", {
      subject,
      contents: newNoticeContents,
    });
    if(prop.onUpdate) prop.onUpdate( data );
    // setNoticeCount( data.count );
    // setNotice(data.list);
    setShowNewInput(false);
  }

  return (
    <div className="flex my-5">
      {!showNewinput && (
        <CTL_Button className="w-full" onClick={() => setShowNewInput(true)}>
          <div>새 공지 등록</div>
        </CTL_Button>
      )}

      {showNewinput && (
        <div className="flex flex-col gap-2">
          <CTL_Input
            label="제목"
            value={subject}
            onChange={(v: string) => setSubject(v)}
          />
          <CTL_GroupLabel label="게시글">
            <ReactQuill
              theme="snow"
              className="w-full"
              value={newNoticeContents}
              onChange={setNewNoticeContents}
            ></ReactQuill>
          </CTL_GroupLabel>
          <div className="flex justify-center gap-5">
            <CTL_Button onClick={() => setShowNewInput(false)}>
              <div>취소</div>
            </CTL_Button>

            <CTL_Button onClick={() => _commitAdd()}>
              <div>등록</div>
            </CTL_Button>
          </div>
        </div>
      )}
    </div>
  );
}
